<template>
    <svg class="country-global-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.9999 22.909C18.0248 22.909 22.909 18.0248 22.909 11.9999C22.909 5.97499 18.0248 1.09082 11.9999 1.09082C5.97499 1.09082 1.09082 5.97499 1.09082 11.9999C1.09082 18.0248 5.97499 22.909 11.9999 22.909Z"
        />
        <path
            d="M11.9824 22.9091C16.2038 22.9091 19.626 18.0249 19.626 12C19.626 5.97505 16.2038 1.09088 11.9824 1.09088C7.761 1.09088 4.33887 5.97505 4.33887 12C4.33887 18.0249 7.761 22.9091 11.9824 22.9091Z"
        />
        <path
            d="M12.0001 22.9091C13.9124 22.9091 15.4626 18.0249 15.4626 12C15.4626 5.97505 13.9124 1.09088 12.0001 1.09088C10.0879 1.09088 8.53772 5.97505 8.53772 12C8.53772 18.0249 10.0879 22.9091 12.0001 22.9091Z"
        />
        <path d="M2.92883 5.93939H21.0993" />
        <path d="M2.92896 17.9427H21.0994" />
        <path d="M1.09082 11.9406H22.9084" />
        <path
            d="M11.9999 22.909C18.0248 22.909 22.909 18.0248 22.909 11.9999C22.909 5.97499 18.0248 1.09082 11.9999 1.09082C5.97499 1.09082 1.09082 5.97499 1.09082 11.9999C1.09082 18.0248 5.97499 22.909 11.9999 22.909Z"
        />
    </svg>
</template>

<style lang="scss">
    .country-global-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        color: var(--joy-color-neutral-60);

        path {
            stroke: currentColor;
            stroke-miterlimit: 10;
            stroke-width: 1.2;

            &:last-child {
                color: var(--joy-color-neutral-60);
            }
        }
    }
</style>
